const events = {
  PAYMENT_SETTINGS: {
    EDIT_CARD: 'paymentSettings.editCard',
    EDIT_BANK: 'paymentSettings.editBank',
  },
  PAYMENT_OPTIONS_UPDATE: 'paymentUpdate'
};

export default events;
